var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"bubble-icon-container"},[_c('img',{attrs:{"src":require("../../static/img/Message.png")}}),_c('div',{staticClass:"message-count",class:_vm.messageCount > 0 ? 'message-unread' : '',on:{"click":_vm.clickMessages}},[_vm._v(_vm._s(_vm.messageCount))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }